module.exports = __webpack_public_path__ + "img/dashboard_person_search.0178ca6a.svg";